export default __webpack_public_path__ + "static/media/allianz.652800f1.png";